import React from 'react';
import PropTypes from 'prop-types';

function TwoColsTextWidget(props) {
    if (!props?.title && !props?.text && !props?.text2) return null;

    return (
        <div data-test-id="tct-wr" className={"widget widget-twocolstext" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                {props.title ? <h3 data-test-id="tct-title" className={(props?.dark ? "text-white " : "") + "text-sm-center col-12 col-md-6"}>{props.title}</h3> : null}
                {
                    props?.text || props?.text2 ?
                        <div className="row mx-0">
                            {
                                props?.text ?
                                    <div className="col-12 col-md-6 mb-sm-12">
                                        <p data-test-id="tct-left" className={(props?.dark ? 'text-white ' : '') + 'text-medium text-sm-small text-justify text-sm-center'}>{props.text}</p> 
                                    </div>
                                    : null
                            }
                            {
                                props?.text2 ?
                                    <div className="col-12 col-md-6">
                                        <p data-test-id="tct-right" className={(props?.dark ? 'text-white ' : '') + 'text-medium text-sm-small text-justify text-sm-center'}>{props.text2}</p>
                                    </div>
                                    : null
                            }
                        </div>
                        : null
                }
            </div>
        </div>
    )
}

TwoColsTextWidget.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    widget: PropTypes.string
}

export default TwoColsTextWidget;
